import { render, staticRenderFns } from "./peoplelist.vue?vue&type=template&id=46441daa"
import script from "./peoplelist.vue?vue&type=script&lang=js"
export * from "./peoplelist.vue?vue&type=script&lang=js"
import style0 from "./peoplelist.vue?vue&type=style&index=0&id=46441daa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports